// extracted by mini-css-extract-plugin
module.exports = {"likesCount":"styles-module__likesCount___5abb9","likeIcon":"styles-module__likeIcon___uJsUy"};